<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()">×</button>
                <h4 class="modal-title">{{ $t('payment_methods') }}</h4>
            </div>
            <div class="modal-body">
                <form @submit.prevent="approve" class="modal_content">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-xs-4" v-for="(item, index) in payments">
                            <div class="panel panel-info">
                                <div class="panel-heading text-center">
                                <strong>{{ $t('payment_package') }} {{ index +1 }}</strong>
                                </div>
                                <div class="panel-body">
                                    <p><strong>{{ $t('payment_method') }}:</strong></p>
                                    <ul>
                                        <li v-for="payment in item.items">
                                            <strong>{{ payment.payment_method.display_name }}</strong> - {{ payment.installments }}x 
                                            {{ (payment.value + ((payment.fee/100) * payment.value)) / payment.installments | pmlCurrency(currency.symbol) }}
                                            <span v-if="payment.fee > 0">, Taxa: {{ payment.fee }}%</span>
                                        </li>
                                        <li><strong>Total</strong>: {{ calculateTotal(item.items) | pmlCurrency(currency.symbol) }}</li>
                                    </ul>
                                    <div class="text-center">
                                        <label class="label_radio m-r-20">
                                            <input type="radio" v-model="approveParams.quote_payment_id" :value="item.id" />
                                            <span class="pull-left m-r-5"></span> {{ $t('select') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary btn-lg btn-block" @click.prevent="approve" :disabled="!approveParams.quote_payment_id">{{ $t('approve') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from '@/utils/helpers/notify'
    import RoutedModals from '@/utils/mixins/routed-modals'
    import { trans } from '@/utils/helpers/translation'
    import { get, approve } from 'services/my-quotation'

    export default {
        name: 'ApproveMyQuotation',
        mixins: [ RoutedModals ],
        data () {
            return {
                quotation: {},
                isLoading: false,
                approveParams: {
                    quote_payment_id: null
                }
            }
        },
        computed: {
            code () {
                return this.$route.params.code
            },
            record () {
                return this.quotation.quotation || {}
            },
            currency () {
                return this.quotation.currency || {}
            },
            payments () {
                return this.quotation.payments || {}
            }
        },
        mounted () {
            this.isLoading = true

            get(this.code)
                .then(response => {
                    this.quotation = response.data
                    this.$i18n.locale = this.record.language
                })
                .catch(() => {
                    Notify.error(trans('_notifications.error'))
                })
                .then(() => { this.isLoading = false })
        },
        methods: {
            approve () {
                this.isApproving = true

                approve(this.$route.params.code, this.approveParams)
                    .then(response => {
                        this.$router.push({name: 'my-quotation.show', params: {code: this.$route.params.code}})
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => {
                        this.isApproving = false
                        this.$emit('close')
                    })
            },
            calculateTotal (items) {
                return items.reduce((sum, payment) => {
                    return sum + payment.value + ((payment.fee / 100) * payment.value)
                }, 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Approve.vue